<template>
  <div class="mbo-scene mbo-draft">
    <img class="mbo-frame" :src="frame" alt="">

    <template v-for="side in sides">
      <div v-for="(slot, i) in side.bans"
           :key="'ban-' + side.camp + '-' + i"
           :class="['mbo-abs', 'mbo-draft__ban', {'is-current': slot.current, 'is-empty': !slot.hero}]"
           :style="box(side.banX[i] + 3, 548, 91, 91)">
        <MbOverlayHero v-if="slot.hero" :hero="slot.hero"/>
        <span class="mbo-draft__ban-mark">⊘</span>
      </div>

      <div :key="'logo-' + side.camp"
           :class="['mbo-abs', 'mbo-draft__logo']"
           :style="box(side.logoX, 553, 76, 80)">
        <img v-if="side.logo" :src="side.logo" alt="">
        <span v-else>{{ side.short }}</span>
      </div>
      <div :key="'name-' + side.camp" class="mbo-abs mbo-draft__name" :style="box(side.nameX, 553, side.nameW, 80)">
        <MbFitText :text="side.name" :max="38" :min="18"/>
      </div>

      <template v-for="(card, i) in side.cards">
        <!-- портрет героя закрывает статую-заглушку из макета на всю карточку; до пика — фото игрока -->
        <div v-if="card.hero || card.photo"
             :key="'art-' + side.camp + '-' + i"
             class="mbo-abs mbo-draft__art"
             :style="box(side.cardX[i] + 4, 657, 164, 275)">
          <MbOverlayHero v-if="card.hero" :hero="card.hero"/>
          <img v-else class="mbo-draft__photo" :src="card.photo" alt="">
        </div>
        <div v-if="card.current"
             :key="'cur-' + side.camp + '-' + i"
             class="mbo-abs mbo-draft__current"
             :style="box(side.cardX[i], 652, 172, 332)"></div>
        <div v-if="card.hero || card.current"
             :key="'pick-' + side.camp + '-' + i"
             :class="['mbo-abs', 'mbo-draft__pick', {'is-empty': !card.hero}]"
             :style="box(side.cardX[i] + 5, 884, 162, 48)">
          <MbFitText v-if="card.hero" :text="card.hero.name" :max="21" :min="12"/>
          <span v-else>выбирает…</span>
        </div>
        <div :key="'nick-' + side.camp + '-' + i"
             class="mbo-abs mbo-draft__nick"
             :style="box(side.cardX[i] + 4, 936, 164, 44)">
          <MbFitText :text="card.nick" :max="23" :min="12"/>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import frame from '@/assets/images/mlbb-broadcast/draft-frame.png'
import MbFitText from '@/components/MlbbBroadcast/overlay/MbFitText.vue'
import MbOverlayHero from '@/components/MlbbBroadcast/overlay/MbOverlayHero.vue'
import {campByNumber, campLogoUrl, campShortName, campTeamName, playerName, playerPhoto} from '@/common/mlbbBroadcast'
import {banSlots, pickCards} from '@/common/mlbbOverlay'
import {box} from '@/components/MlbbBroadcast/overlay/box'

// Координаты слотов сняты с макета «Драфт фулл.png» (1920×1080); ban — левый верхний угол рамки слота
const LAYOUT = {
  1: {
    banX: [42, 142, 242, 349, 449],
    cardX: [42, 225, 409, 592, 776],
    logoX: 566,
    nameX: 650,
    nameW: 232,
  },
  2: {
    // у красных первый бан — крайний правый слот
    banX: [1782, 1682, 1582, 1475, 1375],
    cardX: [966, 1151, 1336, 1521, 1706],
    logoX: 1278,
    nameX: 1036,
    nameW: 232,
  },
}

export default {
  name: 'MbSceneDraft',
  components: {MbFitText, MbOverlayHero},
  props: {
    battle: {type: Object, required: true},
  },
  data() {
    return {frame}
  },
  computed: {
    sides() {
      return [1, 2].map((n) => {
        const camp = campByNumber(this.battle, n) || {camp: n}
        return {
          camp: n,
          ...LAYOUT[n],
          name: campTeamName(camp),
          short: campShortName(camp).slice(0, 2),
          logo: campLogoUrl(camp),
          bans: banSlots(this.battle, n),
          cards: pickCards(this.battle, n).map((c) => ({...c, nick: playerName(c.player).name, photo: playerPhoto(c.player)})),
        }
      })
    },
  },
  methods: {box},
}
</script>
